// Όλα τα κείμενα διεπαφής, δίγλωσσα.
export const UI = {
  el: {
    heroEyebrow: 'Ένα γεωγραφικό και φιλολογικό αίνιγμα δύο χιλιάδων ετών',
    heroTitle: 'Η αναζήτηση της Ομηρικής Ιθάκης',
    heroOptOverview: 'Συνοπτική παρουσίαση',
    heroOptAnalysis: 'Η πλήρης ανάλυση',
    heroOptQuiz: 'Δοκιμάστε τις γνώσεις σας',
    heroOptBoard: 'Διαδραστικός πίνακας αξιολόγησης θεωριών',
    heroOptArt: 'Ιστορικά τεκμήρια της αναζήτησης',
    artSectionTitle: 'Η Ομηρική Ιθάκη στην τέχνη',
    evEyebrow: 'Πρωτογενείς πηγές',
    evIntro: 'Η αναζήτηση της Ομηρικής Ιθάκης δεν είναι μόνο κείμενα — είναι και εικόνες. Οι χαλκογραφίες του Sir William Gell (1807) αποτύπωσαν πρώτες το τοπίο της Ιθάκης με επιστημονική διάθεση, και ενενήντα χρόνια αργότερα ο Wilhelm Dörpfeld έφερε στο προσκήνιο τη Λευκάδα με την εναλλακτική ανάγνωση του ομηρικού έπους και τις ανασκαφές του. Σε υψηλή ανάλυση, με τις αυθεντικές λεζάντες τους.',
    evGellTitle: 'Οι χαλκογραφίες του Sir William Gell (1807)',
    evGellIntro: 'Ο Άγγλος αρχαιολόγος Sir William Gell περιηγήθηκε την Ιθάκη το 1806 και εξέδωσε το 1807 το «The Geography and Antiquities of Ithaca» — την πρώτη συστηματική τοπογραφία του νησιού, με την ομηρική πρωτεύουσα στον ισθμό του Αετού. Οι 15 πίνακες του βιβλίου (χαλκογραφίες των Tomkins, Wright και Bluck, χάρτες του Neele) παρουσιάζονται εδώ από τα πρωτότυπα σκαν της έκδοσης, σε υψηλή ανάλυση. Κάντε κλικ για μεγέθυνση.',
    evDorpfeldTitle: 'Ο Wilhelm Dörpfeld στη Λευκάδα (1891–1913)',
    evDorpfeldIntro: 'Ο Wilhelm Dörpfeld, συνεργάτης του Schliemann στην Τροία, ανακοίνωσε το 1900 ότι η ομηρική Ιθάκη ήταν η Λευκάδα. Έζησε στο Νυδρί και πραγματοποίησε ανασκαφές στο νησί (1901–1913), κορυφώνοντας τη θεωρία του στο δίτομο «Alt-Ithaka» (1927). Εδώ παρουσιάζονται οι χάρτες του, φωτογραφίες της εποχής και πίνακες από τις ετήσιες ανασκαφικές του αναφορές «Leukas-Ithaka» (1909, 1911) — σε υψηλή ανάλυση. Κάντε κλικ για μεγέθυνση.',
    lightboxClose: 'Κλείσιμο',
    boardEyebrow: 'Διαδραστικό εργαλείο',
    boardTitle: 'Πίνακας αξιολόγησης θεωριών',
    boardIntro: 'Ποια ομηρικά κριτήρια θεωρείτε ισχυρά; Επιλέξτε όσα κρίνετε αποφασιστικά για την ταυτοποίηση της Ιθάκης — στη συνέχεια θα σχηματιστεί ο πίνακας αξιολόγησης των τριών θεωριών μόνο για τα κριτήρια που επιλέξατε.',
    boardStep1: 'Βήμα 1 — Επιλέξτε τα κριτήρια που θεωρείτε ισχυρά',
    boardSelectedCount: 'επιλεγμένα',
    boardBuild: 'Σχηματισμός πίνακα αξιολόγησης',
    boardStep2: 'Βήμα 2 — Ο πίνακας αξιολόγησης για τα κριτήριά σας',
    boardResultNote: 'Ο πίνακας δείχνει πώς αξιολογείται κάθε θεωρία αποκλειστικά στα κριτήρια που επιλέξατε — με βάση την ανάλυση του ιστότοπου.',
    boardBack: 'Αλλαγή επιλογής κριτηρίων',
    boardCompareTitle: 'Σύγκριση των τριών νησιών στα επιλεγμένα κριτήρια',
    boardLockedHint: 'Προεπιλεγμένο κριτήριο — παραμένει πάντα ενεργό',
    boardLockedNote: 'Προεπιλεγμένο κριτήριο — έχει αυξημένη (διπλή) βαρύτητα στην αξιολόγηση',
    boardWeightNote: 'Η τοπωνυμική συνέχεια, ως προεπιλεγμένο κριτήριο, υπολογίζεται με διπλή βαρύτητα στις παραπάνω μπάρες.',
    boardRankBest: 'Πιο ισχυρή ανταπόκριση στα επιλεγμένα κριτήρια',
    boardRankMid: 'Ενδιάμεση ανταπόκριση',
    boardRankWeak: 'Ασθενέστερη ανταπόκριση',
    boardCriterionCol: 'Κριτήριο',
    artPageEyebrow: 'Γκαλερί',
    artPageIntro: 'Η ομηρική Ιθάκη και ο κόσμος της Οδύσσειας — η Πηνελόπη, οι μνηστήρες, ο πολυμήχανος ήρωας — μέσα από έργα τέχνης, από την αρχαιότητα έως τον 19ο αιώνα.',
    heroOptKids: 'Εκπαιδευτικό παιχνίδι',
    heroOptPubs: 'Σχετικές εργασίες – δημοσιεύσεις',
    pubsEyebrow: 'Βιβλιογραφικός οδηγός',
    pubsIntro: 'Οι βασικές εργασίες και δημοσιεύσεις πάνω στο ζήτημα της ομηρικής Ιθάκης — από το Alt-Ithaka του Dörpfeld (1927) έως τη φιλολογική «διάσωση» των Diggle & Underhill (2026).',
    pubsNote: 'Οι παραπομπές ακολουθούν τη βιβλιογραφία της πλήρους ανάλυσης. Όπου η εργασία διατίθεται ελεύθερα στο διαδίκτυο, παρέχεται ενεργός σύνδεσμος. Οι ελληνικές αποδόσεις ξενόγλωσσων τίτλων είναι δικές μας. Για το ιστορικό της διαμάχης δείτε το χρονολόγιο στην ενότητα «Η πλήρης ανάλυση».',
    pubsLinkLabel: 'Διαθέσιμο online',
    biblioClassicTitle: 'Κλασική βιβλιογραφία',
    biblioRecentTitle: 'Νεότερη βιβλιογραφία',
    heroOptProgram: 'Το Πρόγραμμα «Ομηρική Ιθάκη»',
    backHome: '← Αρχική σελίδα',
    overviewModalClose: 'Κλείσιμο',
    heroSoundOnLabel: 'Άνοιγμα ήχου',
    heroSoundOffLabel: 'Σίγαση',
    heroReplayLabel: 'Ξανά από την αρχή',
    heroSkipLabel: 'Παράλειψη παρουσίασης',
    heroVideoCaptions: [
      'Από τον Όμηρο έως σήμερα — 2.800 χρόνια αναζήτησης.',
      'Τρεις θεωρίες. Ένα άλυτο αίνιγμα.',
      'Ποιο νησί ήταν η πατρίδα του Οδυσσέα;',
      'Η αναζήτηση της Ομηρικής Ιθάκης',
    ],
    heroVideoTitleA: 'Η αναζήτηση της',
    heroVideoTitleB: 'Ομηρικής Ιθάκης',
    heroVideoSponsor: 'Μια χορηγία της',
    heroCredit1: 'Η ιστοσελίδα δημιουργήθηκε με τη χορηγία της NOVUS CODEX. Ανάπτυξη κειμένων και ιστοσελίδας με χρήση πόρων τεχνητής νοημοσύνης του Claude, μέσω διαδικασίας καθοδηγούμενης συγγραφής και υποβοηθούμενης έρευνας.',
    heroCredit2: 'Ιδέα – σχεδίαση – επιμέλεια:',
    authorName: 'Ξενοφών Δ. Γράψας',
    overviewEyebrow: 'Επισκόπηση',
    overviewTitle: 'Συνοπτική παρουσίαση',
    overviewIntro1: 'Το ζήτημα ξεκινά από μια αντίφαση του ομηρικού κειμένου: η Ιθάκη περιγράφεται ως «χθαμαλή» και κείμενη «πρὸς ζόφον», ενώ τα γύρω νησιά «πρὸς ἠῶ» — περιγραφή που η σημερινή Ιθάκη δυσκολεύεται να καλύψει. Γύρω από αυτή την αντίφαση κινούνται οι βασικές κατευθύνσεις της έρευνας: η κρατούσα άποψη, που ταυτίζει την ομηρική Ιθάκη με το σημερινό νησί στηριζόμενη στην αδιάλειπτη τοπωνυμική και λατρευτική συνέχεια, και δύο θεωρίες που την αμφισβητούν — η Λευκάδα του Wilhelm Dörpfeld (1900), με γεωγραφικά κριτήρια και τη διαδρομή του Τηλέμαχου, και η Παλική των Bittlestone, Diggle και Underhill (2005–2026), με το φιλολογικό επιχείρημα ότι ο Όμηρος δεν αποκαλεί ποτέ ρητά την Ιθάκη «νῆσο».',
    overviewIntro2: 'Η αντιπαράθεση στέκεται πάνω σε τέσσερις πυλώνες: τα ομηρικά χωρία, τους αρχαίους ερμηνευτές (Στράβων), τη γεωγραφική και γεωλογική τεκμηρίωση, και τη χαρτογραφική παράδοση του 18ου αιώνα. Οι εννέα συνόψεις που ακολουθούν δίνουν την ουσία κάθε θέματος — και οδηγούν στο αναλυτικό κείμενο για περαιτέρω εξειδίκευση.',
    overviewCardCta: 'Ανάλυση',
    matrixEyebrow: 'Κεντρικός συγκριτικός πίνακας',
    matrixTitle: 'Τρεις θεωρίες, δέκα κριτήρια',
    matrixDesc: 'Πόσο καλά ικανοποιεί κάθε υποψήφια Ιθάκη τα κρίσιμα κριτήρια ταυτοποίησης; Η αξιολόγηση είναι ενδεικτική στάθμιση των επιχειρημάτων όπως αναπτύσσονται στο αναλυτικό κείμενο — καμία θεωρία δεν πλησιάζει τη βεβαιότητα.',
    matrixCriterionCol: 'Κριτήριο',
    mapEyebrow: 'Η χαρτογραφική μαρτυρία',
    mapTitle: 'Ο χάρτης του 1797',
    mapDesc: 'Η έγχρωμη γερμανική έκδοση του χάρτη του Jacques-Nicolas Bellin, επίσημου χαρτογράφου του γαλλικού ναυτικού: «Karte von den Inseln St. Maura, Cephallenia, Zante und den anliegenden Küsten» — το Ιόνιο σύμπλεγμα όπως το έβλεπε η Ευρώπη λίγα χρόνια πριν ο Dörpfeld ταράξει τα νερά.',
    mapLabelsTitle: 'Τα 4 νησιά πάνω στον χάρτη',
    mapWhyPrefix: 'Γιατί έχει σημασία:',
    mapWhy: 'η γκραβούρα αποτυπώνει την «επίσημη» γεωγραφία πριν από κάθε αμφισβήτηση: τέσσερα νησιά, τέσσερα ονόματα, μια φαινομενικά τακτοποιημένη εικόνα. Ακριβώς αυτή τη διάταξη ανακατεύουν οι θεωρίες Dörpfeld και Παλικής — το παζλ των ονομάτων αναλύεται στο Κεφάλαιο 13.',
    theoryEyebrow: 'Το παζλ των ονομάτων',
    theoryTitle: 'Πού τοποθετεί κάθε θεωρία την Ιθάκη;',
    theoryDesc: 'Επιλέξτε θεωρία και δείτε πώς ανακατανέμονται τα τέσσερα ομηρικά ονόματα — πάνω στον αυθεντικό έγχρωμο χάρτη Bellin του 1797.',
    theoryTabsLabel: 'Επιλογή θεωρίας',
    theoryFullSize: 'Πλήρες μέγεθος',
    timelineEyebrow: 'Δύο χιλιάδες χρόνια αναζήτησης',
    timelineTitle: 'Χρονολόγιο της διαμάχης',
    biblioTitle: 'Βιβλιογραφία',
    analysisEyebrow: 'Το πλήρες κείμενο',
    analysisAbstract: 'Το ερώτημα «ποιο πραγματικό νησί είναι η Ιθάκη του Οδυσσέα» απασχολεί σχολιαστές, γεωγράφους και αρχαιολόγους από την αρχαιότητα μέχρι σήμερα — από τον Ερατοσθένη και τον Στράβωνα έως τον Wilhelm Dörpfeld και την πρόσφατη μελέτη των James Diggle και John Underhill (2026). Το παρόν κείμενο επιχειρεί μια συστηματική παρουσίαση του ζητήματος: από το ευρύτερο Ομηρικό Ζήτημα, μέσα από τις δύο κύριες θεωρίες αμφισβήτησης της παραδοσιακής ταύτισης, στις πρωτογενείς πηγές, και σε μια συγκριτική στάθμιση των επιχειρημάτων.',
    aboutEyebrow: 'Σχετικά με το έργο',
    aboutDedication: 'Αφιέρωση',
    aboutDedicationText: 'Στον πατέρα μου, Δημήτριο Ξ. Γράψα (1931–2019).',
    aboutTitle: 'Μεθοδολογία και Credits',
    aboutMethodTitle: 'Μεθοδολογία',
    aboutCreditsTitle: 'Credits',
    aboutMethodology: [
      'Το περιεχόμενο προέρχεται από το δοκίμιο «Η αναζήτηση της Ομηρικής Ιθάκης» και παρουσιάζεται με διπλή ανάγνωση: συνοπτικοί πίνακες και πλήρες αναλυτικό κείμενο.',
      'Οι τρεις θεωρίες αξιολογούνται με τα ίδια δέκα κριτήρια, ταυτόχρονα και χωρίς προκατάληψη υπέρ κάποιας.',
      'Τα αρχαία χωρία παρατίθενται στο πρωτότυπο με νεοελληνική απόδοση και σχολιασμό.',
      'Οι χάρτες (Bellin 1797, Delisle 1794, Coronelli) είναι έργα κοινού κτήματος από το Wikimedia Commons.',
    ],
    aboutCreditAuthor: 'Ιδέα – σχεδίαση – επιμέλεια:',
    aboutCreditSponsor: 'Χορηγία:',
    aboutCreditAi: 'Ανάπτυξη κειμένων και ιστοσελίδας με χρήση πόρων τεχνητής νοημοσύνης του Claude, μέσω διαδικασίας καθοδηγούμενης συγγραφής και υποβοηθούμενης έρευνας.',
    aboutCreditMusic: 'Μουσική εισαγωγής: «Heavy Heart» — Kevin MacLeod (incompetech.com), άδεια CC BY 4.0.',
    aboutCopyright: '© 2026 NOVUS CODEX · Ξενοφών Δ. Γράψας — Με επιφύλαξη παντός δικαιώματος.',
    footerCredit: 'Η ιστοσελίδα δημιουργήθηκε με τη χορηγία της NOVUS CODEX. Ανάπτυξη κειμένων και ιστοσελίδας με χρήση πόρων τεχνητής νοημοσύνης του Claude, μέσω διαδικασίας καθοδηγούμενης συγγραφής και υποβοηθούμενης έρευνας.',
    footerCreditAuthor: 'Ιδέα – σχεδίαση – επιμέλεια: Ξενοφών Δ. Γράψας',
    footerCopyright: '© 2026 NOVUS CODEX · Ξενοφών Δ. Γράψας — Με επιφύλαξη παντός δικαιώματος.',
    quoteNoteLabel: 'Σχολιασμός:',
    strengthsLabel: 'Δυνατά σημεία',
    weaknessesLabel: 'Αδυναμίες',
    strengthPrefix: 'Ισχύς:',
    namingFootnote: 'Και οι δύο ανταγωνιστικές θεωρίες συμφωνούν σε ένα σημείο: η Ζάκυνθος παραμένει σταθερή σε κάθε σενάριο. Το σύνολο της αβεβαιότητας συγκεντρώνεται στα άλλα τρία ονόματα.',
    tocGroups: [
      { label: 'Είσοδος', items: [
        { id: 'overview', label: 'Συνοπτική παρουσίαση' },
        { id: 'prologue', label: 'Πρόλογος' },
      ]},
      { label: 'Μέρος 1 — Το Ομηρικό Ζήτημα', items: [
        { id: 'ch1', label: 'Αναλυτές & Ενωτικοί' },
        { id: 'ch2', label: 'Ο Κατάλογος των Πλοίων' },
        { id: 'ch3', label: 'Η Ραψωδία 24' },
      ]},
      { label: 'Μέρος 2 — Θεωρίες αμφισβήτησης', items: [
        { id: 'ch4', label: 'Dörpfeld & η Λευκάδα' },
        { id: 'ch5', label: 'Η θεωρία της Παλικής' },
        { id: 'ch6', label: 'Ενδιάμεσες θεωρίες' },
      ]},
      { label: 'Μέρος 3 — Οι πηγές', items: [
        { id: 'ch7', label: 'Τα ομηρικά χωρία' },
        { id: 'ch8', label: 'Ο Στράβων' },
        { id: 'ch9', label: 'Ο Θουκυδίδης' },
        { id: 'ch10', label: 'Το αίνιγμα της «νήσου»' },
      ]},
      { label: 'Μέρος 4 — Αντιπαράθεση', items: [
        { id: 'ch11', label: 'Πίνακες επιχειρημάτων' },
        { id: 'ch12', label: 'Η γεωγραφική δοκιμασία' },
        { id: 'ch13', label: 'Το απροσδιόριστο νησί' },
      ]},
      { label: 'Κατάληξη', items: [
        { id: 'epilogue', label: 'Επίλογος' },
        { id: 'bibliography', label: 'Βιβλιογραφία' },
      ]},
    ],
    tocAria: 'Πίνακας περιεχομένων',
    tocToggle: 'Περιεχόμενα',
  },
  en: {
    heroEyebrow: 'A two-thousand-year-old geographical and philological enigma',
    heroTitle: 'The Search for Homeric Ithaca',
    heroOptOverview: 'Overview',
    heroOptAnalysis: 'The full analysis',
    heroOptQuiz: 'Test your knowledge',
    heroOptBoard: 'Interactive theory evaluation board',
    heroOptArt: 'Historical Evidence of the Search',
    artSectionTitle: 'Homeric Ithaca in Art',
    evEyebrow: 'Primary sources',
    evIntro: 'The search for Homeric Ithaca is not only texts — it is also images. The engravings of Sir William Gell (1807) were the first to capture the landscape of Ithaca with a scientific eye, and ninety years later Wilhelm Dörpfeld brought Lefkada to the forefront with his alternative reading of the Homeric epic and his excavations. In high resolution, with their authentic captions.',
    evGellTitle: 'The engravings of Sir William Gell (1807)',
    evGellIntro: 'The English antiquarian Sir William Gell travelled through Ithaca in 1806 and in 1807 published “The Geography and Antiquities of Ithaca” — the first systematic topography of the island, placing the Homeric capital at the isthmus of Aetos. The book’s 15 plates (engraved by Tomkins, Wright and Bluck, maps by Neele) are presented here from the original edition’s scans, in high resolution. Click to enlarge.',
    evDorpfeldTitle: 'Wilhelm Dörpfeld in Lefkada (1891–1913)',
    evDorpfeldIntro: 'Wilhelm Dörpfeld, Schliemann’s collaborator at Troy, announced in 1900 that Homeric Ithaca was Lefkada. He lived at Nydri and excavated on the island (1901–1913), culminating his theory in the two-volume “Alt-Ithaka” (1927). Presented here are his maps, period photographs and plates from his annual excavation reports “Leukas-Ithaka” (1909, 1911) — in high resolution. Click to enlarge.',
    lightboxClose: 'Close',
    boardEyebrow: 'Interactive tool',
    boardTitle: 'Theory evaluation board',
    boardIntro: 'Which Homeric criteria do you consider strong? Select those you judge decisive for identifying Ithaca — the evaluation board of the three theories will then be formed only for the criteria you chose.',
    boardStep1: 'Step 1 — Select the criteria you consider strong',
    boardSelectedCount: 'selected',
    boardBuild: 'Build the evaluation board',
    boardStep2: 'Step 2 — The evaluation board for your criteria',
    boardResultNote: 'The board shows how each theory is rated exclusively on the criteria you selected — based on this site’s analysis.',
    boardBack: 'Change criteria selection',
    boardCompareTitle: 'Comparison of the three islands on your selected criteria',
    boardLockedHint: 'Preselected criterion — always stays active',
    boardLockedNote: 'Preselected criterion — carries increased (double) weight in the assessment',
    boardWeightNote: 'Toponymic continuity, as the preselected criterion, is counted with double weight in the bars above.',
    boardRankBest: 'Strongest response to the selected criteria',
    boardRankMid: 'Intermediate response',
    boardRankWeak: 'Weakest response',
    boardCriterionCol: 'Criterion',
    artPageEyebrow: 'Gallery',
    artPageIntro: 'Homeric Ithaca and the world of the Odyssey — Penelope, the suitors, the resourceful hero — through works of art, from antiquity to the 19th century.',
    heroOptKids: 'Educational game',
    heroOptPubs: 'Related works & publications',
    pubsEyebrow: 'Bibliographic guide',
    pubsIntro: 'The principal works and publications on the question of Homeric Ithaca — from Dörpfeld’s Alt-Ithaka (1927) to the philological “rescue” by Diggle & Underhill (2026).',
    pubsNote: 'The references follow the bibliography of the full analysis. Wherever a work is freely available online, an active link is provided. Greek renderings of foreign-language titles are our own. For the history of the controversy, see the timeline in “The full analysis”.',
    pubsLinkLabel: 'Available online',
    biblioClassicTitle: 'Classic bibliography',
    biblioRecentTitle: 'Recent bibliography',
    heroOptProgram: 'The "Homeric Ithaca" Programme',
    backHome: '← Home',
    overviewModalClose: 'Close',
    heroSoundOnLabel: 'Turn sound on',
    heroSoundOffLabel: 'Mute',
    heroReplayLabel: 'Play again',
    heroSkipLabel: 'Skip presentation',
    heroVideoCaptions: [
      'From Homer to today — 2,800 years of searching.',
      'Three theories. One unsolved enigma.',
      'Which island was Odysseus\u2019 homeland?',
      'The Search for Homeric Ithaca',
    ],
    heroVideoTitleA: 'The Search for',
    heroVideoTitleB: 'Homeric Ithaca',
    heroVideoSponsor: 'Sponsored by',
    heroCredit1: 'This website was created with the sponsorship of NOVUS CODEX. Text and website development using Claude AI resources, through a process of guided writing and assisted research.',
    heroCredit2: 'Concept – design – editing:',
    authorName: 'Xenofon D. Grapsas',
    overviewEyebrow: 'Overview',
    overviewTitle: 'The issue at a glance',
    overviewIntro1: 'The question begins with a contradiction in the Homeric text: Ithaca is described as "chthamale" (low-lying) and lying "towards zophos" (the north/darkness quarter), while the surrounding islands lie "towards the dawn" — a description that present-day Ithaca struggles to match. Around this contradiction revolve the main lines of inquiry: the prevailing view, which identifies Homeric Ithaca with the present-day island on the strength of unbroken toponymic and cult continuity, and two theories that challenge it — Dörpfeld\u2019s Lefkada (1900), argued on geographical criteria and Telemachus\u2019 sea route, and the Paliki of Bittlestone, Diggle and Underhill (2005–2026), argued on the philological point that Homer never once calls Ithaca a "nēsos" (island).',
    overviewIntro2: 'The debate rests on four pillars: the Homeric passages, the ancient interpreters (Strabo), geographical and geological evidence, and the cartographic tradition of the 18th century. The nine summaries below give the essence of each topic — and lead into the detailed text for those who want to go deeper.',
    overviewCardCta: 'Analysis',
    matrixEyebrow: 'The central comparison table',
    matrixTitle: 'Three theories, ten criteria',
    matrixDesc: 'How well does each candidate Ithaca satisfy the critical identification criteria? The grading is an indicative weighing of the arguments as developed in the detailed text — no theory comes close to certainty.',
    matrixCriterionCol: 'Criterion',
    mapEyebrow: 'The cartographic testimony',
    mapTitle: 'The map of 1797',
    mapDesc: 'The hand-coloured German edition of the map by Jacques-Nicolas Bellin, official cartographer of the French navy: "Karte von den Inseln St. Maura, Cephallenia, Zante und den anliegenden Küsten" — the Ionian archipelago as Europe saw it a few years before Dörpfeld troubled the waters.',
    mapLabelsTitle: 'The 4 islands on the map',
    mapWhyPrefix: 'Why it matters:',
    mapWhy: 'the engraving captures the "official" geography before any dispute: four islands, four names, a seemingly settled picture. This is precisely the arrangement that the Lefkada and Paliki theories reshuffle — the puzzle of the names is analysed in Chapter 13.',
    theoryEyebrow: 'The puzzle of the names',
    theoryTitle: 'Where does each theory place Ithaca?',
    theoryDesc: 'Choose a theory and see how the four Homeric names are redistributed — overlaid on the authentic coloured Bellin map of 1797.',
    theoryTabsLabel: 'Choose a theory',
    theoryFullSize: 'Full size',
    timelineEyebrow: 'Two thousand years of searching',
    timelineTitle: 'Timeline of the controversy',
    biblioTitle: 'Bibliography',
    analysisEyebrow: 'The full text',
    analysisAbstract: 'The question “which real island is Odysseus’ Ithaca” has occupied commentators, geographers and archaeologists from antiquity to the present day — from Eratosthenes and Strabo to Wilhelm Dörpfeld and the recent study by James Diggle and John Underhill (2026). The present text attempts a systematic presentation of the problem: from the broader Homeric Question, through the two main theories challenging the traditional identification, to the primary sources, and to a comparative weighing of the arguments.',
    aboutEyebrow: 'About this project',
    aboutDedication: 'Dedication',
    aboutDedicationText: 'To my father, Dimitrios X. Grapsas (1931–2019).',
    aboutTitle: 'Methodology and Credits',
    aboutMethodTitle: 'Methodology',
    aboutCreditsTitle: 'Credits',
    aboutMethodology: [
      'The content derives from the essay "The Search for Homeric Ithaca" and is presented as a dual reading experience: summary tables and the full analytical text.',
      'The three theories are assessed against the same ten criteria, simultaneously and without bias towards any one of them.',
      'Ancient passages are quoted in the original with translation and commentary.',
      'The maps (Bellin 1797, Delisle 1794, Coronelli) are public-domain works from Wikimedia Commons.',
    ],
    aboutCreditAuthor: 'Concept – design – editing:',
    aboutCreditSponsor: 'Sponsor:',
    aboutCreditAi: 'Text and website development using Claude AI resources, through a process of guided writing and assisted research.',
    aboutCreditMusic: 'Intro music: "Heavy Heart" — Kevin MacLeod (incompetech.com), CC BY 4.0 license.',
    aboutCopyright: '© 2026 NOVUS CODEX · Xenofon D. Grapsas — All rights reserved.',
    footerCredit: 'This website was created with the sponsorship of NOVUS CODEX. Text and website development using Claude AI resources, through a process of guided writing and assisted research.',
    footerCreditAuthor: 'Concept – design – editing: Xenofon D. Grapsas',
    footerCopyright: '© 2026 NOVUS CODEX · Xenofon D. Grapsas — All rights reserved.',
    quoteNoteLabel: 'Commentary:',
    strengthsLabel: 'Strengths',
    weaknessesLabel: 'Weaknesses',
    strengthPrefix: 'Strength:',
    namingFootnote: 'Both rival theories agree on one point: Zakynthos remains fixed in every scenario. The entire uncertainty is concentrated in the other three names.',
    tocGroups: [
      { label: 'Entrance', items: [
        { id: 'overview', label: 'Overview' },
        { id: 'prologue', label: 'Prologue' },
      ]},
      { label: 'Part 1 — The Homeric Question', items: [
        { id: 'ch1', label: 'Analysts & Unitarians' },
        { id: 'ch2', label: 'The Catalogue of Ships' },
        { id: 'ch3', label: 'Book 24' },
      ]},
      { label: 'Part 2 — The rival theories', items: [
        { id: 'ch4', label: 'Dörpfeld & Lefkada' },
        { id: 'ch5', label: 'The Paliki theory' },
        { id: 'ch6', label: 'Intermediate theories' },
      ]},
      { label: 'Part 3 — The sources', items: [
        { id: 'ch7', label: 'The Homeric passages' },
        { id: 'ch8', label: 'Strabo' },
        { id: 'ch9', label: 'Thucydides' },
        { id: 'ch10', label: 'The "nēsos" riddle' },
      ]},
      { label: 'Part 4 — The confrontation', items: [
        { id: 'ch11', label: 'Tables of arguments' },
        { id: 'ch12', label: 'The geographical test' },
        { id: 'ch13', label: 'The indeterminate island' },
      ]},
      { label: 'Conclusion', items: [
        { id: 'epilogue', label: 'Epilogue' },
        { id: 'bibliography', label: 'Bibliography' },
      ]},
    ],
    tocAria: 'Table of contents',
    tocToggle: 'Contents',
  },
};
